const API_AUTH_HOST = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('hlg')) {
    return 'https://api.hlg-plataforma.grupoa.education/v2/safea-client'
  }
  return 'https://api.plataforma.grupoa.education/v2/safea-client'
}

const API_MAINTAINER_HOST = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('hlg')) {
    return 'https://hlg.api.contract-sagah.grupoa.education/api/v1'
  }

  return 'https://api.contract-sagah.grupoa.education/api/v1'
}

const API_AUTH_URL = `${API_AUTH_HOST()}/auth/signin/operations`
const API_URL = `${API_MAINTAINER_HOST()}`
const API_MAINTAINER = `${API_URL}/account`
const API_STAGES = `${API_URL}/stages`
const API_MODELS = `${API_URL}/models`
const API_TYPES = `${API_URL}/types`
const API_CLIENTS = `${API_URL}/clients`
const API_CLIENT = `${API_URL}/client`
const API_POWERBI = `${API_URL}/powerbi`
const API_POWERBI_CLIENT = `${API_URL}/powerbiclient`

export default {
  API_AUTH_HOST,
  API_AUTH_URL,
  API_MAINTAINER,
  API_STAGES,
  API_MODELS,
  API_CLIENTS,
  API_CLIENT,
  API_TYPES,
  API_POWERBI,
  API_POWERBI_CLIENT
}
